import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INCREASE_WIRE_BASE_PATH } from '../../../../../../../../../features/vendor/increase/wire/increase-wire-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'increase-wire-list',
        label: 'Increase',
        to: INCREASE_WIRE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
